export default __webpack_public_path__ + "static/principles-of-use-dont-dark-80a3edc39762aeb0a83b1ec67bcb7168acd934ea22691906298e11c059a21490.png";